import { useRecoilValue } from 'recoil';
import { platform } from '../../native/platform';
import { appVersionState } from '../../native/store/appVersionState';

export const useCheckValidAppVersion = (
  androidVersion: string,
  iosVersion: string,
): boolean | undefined => {
  const currentAppVersion = parseInt(
    useRecoilValue(appVersionState).split('.').join(''),
  );

  if (platform === 'web') return true;

  if (platform === 'android') {
    const AOS_VERSION = parseInt(androidVersion.split('.').join(''));
    return currentAppVersion > AOS_VERSION;
  }

  if (platform === 'ios') {
    const IOS_VERSION = parseInt(iosVersion.split('.').join(''));
    return currentAppVersion > IOS_VERSION;
  }
};
//prev version
export const preScalpV3AndForeheadV2 = {
  android: '1.2.5',
  ios: '1.1.9',
} as const;
